export default import.meta.ROLLDOWN_FILE_URL_hGxfpHXQB1mRKJWHu5xV3Q